import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Axios from "axios";

import { useStyles } from "../../../../Components/CSS/FormStyle.css";
import { url } from "../../../../Config/Config";
import { years } from "../../../../Components/Data/Session";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import FormLoader from "../../../../Components/FormLoader/FormLoader";

class ExamFilterForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      examList: [],
      classList: [],
      facultyError: "",
      groupError: "",
      sectionError: "",
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    try {
      const examResponse = await Axios.get(`${url}/api/exam-types`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (examResponse.data.examTypes.length !== 0) {
        this.setState({
          examList: examResponse.data.examTypes,
        });
      }
      const classResponse = await Axios.get(`${url}/api/schoolclass`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (classResponse.data.classes.length !== 0) {
        this.setState({
          classList: classResponse.data.classes,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getData();
      }
    }
  };

  filterFaculty = () => {
    const facultyFilter = this.state.classList
      .filter((filter) => filter.className === this.props.data.class)
      .map((filter) => filter.faculty);
    let status = facultyFilter.map((filter) => {
      return filter === null || filter === undefined ? false : true;
    });
    if (status.includes(false)) {
      return false;
    } else {
      return true;
    }
  };

  checkError = () => {
    let facultyError = "";
    let groupError = "";
    let sectionError = "";
    let status = this.filterFaculty();

    if (status) {
      if (!this.props.data.faculty) {
        facultyError = "Please Enter Faculty";
      }
    }

    if (this.props.data.faculty) {
      if (!this.props.data.group) {
        groupError = "Please select group ";
      }
    }

    if (this.props.data.section === "") {
      sectionError = "Select one of the section";
    }

    if (facultyError || groupError || sectionError) {
      this.setState({
        facultyError,
        groupError,
        sectionError,
      });
      return true;
    } else {
      this.setState({
        facultyError: "",
        groupError: "",
        sectionError: "",
      });
      return false;
    }
  };

  handleInitialSubmit = (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      this.props.handleSubmit(e);
    }
  };

  render() {
    const { classes, data, handleChangeClass, handleChange } = this.props;
    const classFilter = this.state.classList.map((data) => data.className);
    const facultyFilter = this.state.classList
      .filter((filter) => filter.className === data.class)
      .map((filter) => (filter.faculty ? filter.faculty : ""));
    const groupFilter = this.state.classList
      .filter(
        (filter) =>
          filter.className === data.class && filter.faculty === data.faculty
      )
      .map((filter) => (filter.group ? filter.group : ""));
    const sectionFilterClass = this.state.classList
      .filter((filter) => filter.className === data.class)
      .map((filter) => filter.section);
    const sectionFilter = this.state.classList
      .filter(
        (filter) =>
          filter.className === data.class &&
          filter.faculty === data.faculty &&
          filter.group === data.group
      )
      .map((filter) => filter.section);
    return (
      <form onSubmit={this.handleInitialSubmit}>
        <div>
          <TextField
            name="session"
            label="Session"
            select
            required
            variant="outlined"
            margin="normal"
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            className={classes.inputWithMargin}
            value={data.session}
            onChange={handleChange}
          >
            <option value="">Select Model Year</option>
            {years.map((year, index) => (
              <option key={index} value={year}>
                {year}
              </option>
            ))}
          </TextField>

          <TextField
            name="exam"
            select
            required
            label="Exam Type"
            variant="outlined"
            margin="normal"
            className={classes.inputWithMargin}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.exam}
            onChange={handleChange}
          >
            <option value="">Select Any One</option>
            {this.state.examList.map((exam, index) => (
              <option key={index} value={exam.name}>
                {exam.name}
              </option>
            ))}
          </TextField>

          <TextField
            name="class"
            select
            required
            label="Class"
            variant="outlined"
            margin="normal"
            className={classes.inputWithMargin}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.class}
            onChange={handleChangeClass}
          >
            <option value="">Select Any One</option>
            {classFilter
              .filter((value, index) => classFilter.indexOf(value) === index)
              .map((classData, index) => (
                <option key={index} value={classData}>
                  {classData}
                </option>
              ))}
          </TextField>
          <TextField
            name="faculty"
            select
            label="Faculty"
            variant="outlined"
            margin="normal"
            error={this.state.facultyError ? true : false}
            helperText={
              this.state.facultyError
                ? this.state.facultyError
                : data.faculty
                ? null
                : facultyFilter.length === 0
                ? "Please Select Class to get faculties"
                : "No any faculty for this class"
            }
            className={classes.inputWithMargin}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.faculty}
            onChange={handleChange}
          >
            <option value="">Select Any One</option>
            {facultyFilter
              .filter((value, index) => facultyFilter.indexOf(value) === index)
              .map((classData, index) => (
                <option key={index} value={classData}>
                  {classData}
                </option>
              ))}
          </TextField>

          <TextField
            name="group"
            select
            label="Group"
            variant="outlined"
            margin="normal"
            error={this.state.groupError ? true : false}
            helperText={
              this.state.groupError
                ? this.state.groupError
                : data.group
                ? null
                : groupFilter.length === 0
                ? "Please Select Faculty to get groups"
                : "No any group for this group"
            }
            SelectProps={{ native: true }}
            className={classes.inputWithMargin}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.group}
            onChange={handleChange}
          >
            <option value="">Select Any One</option>
            {groupFilter
              .filter((value, index) => groupFilter.indexOf(value) === index)
              .map((group, index) => (
                <option key={index} value={group}>
                  {group}
                </option>
              ))}
          </TextField>

          <TextField
            name="section"
            select
            required
            label="Section"
            variant="outlined"
            margin="normal"
            error={this.state.sectionError ? true : false}
            helperText={
              this.state.sectionError
                ? this.state.sectionError
                : sectionFilter.length === 0
                ? "Please Select groups or class to get sections"
                : null
            }
            className={classes.inputWithMargin}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.section}
            onChange={handleChange}
          >
            <option value="selected">Select Any One</option>
            {data.faculty && data.group
              ? sectionFilter.length !== 0 &&
                sectionFilter.map((section) =>
                  section.map((data, index) => (
                    <option key={index} value={data.name}>
                      {data.name}
                    </option>
                  ))
                )
              : sectionFilterClass.length !== 0 &&
                sectionFilterClass.map((section) =>
                  section.map((data, index) => (
                    <option key={index} value={data.name}>
                      {data.name}
                    </option>
                  ))
                )}
          </TextField>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Button
            type="submit"
            variant="outlined"
            color="primary"
            className={classes.buttonStyle}
          >
            {this.props.buttonLabel}
          </Button>

          {this.props.loading && <FormLoader />}
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(ExamFilterForm));
